import { ItemData } from 'core/models/Template'

export const COURSES_CATALOG_TYPE = 'courses' as const

export const COURSES_CATALOG_CONFIG = {
    type: COURSES_CATALOG_TYPE,
    fixedHeader: true,
    isExistRightToolbar: false,
    treeView: false,
} as const

export type CoursesSelectedItems = ItemData[]
